import axios from 'axios'

export default {
    tournaments() {
        return axios.get('/web-api/tournaments');
    },

    featuredTournaments() {
        return axios.get('/web-api/tournaments?featured=1');
    },

    loadTournament(id) {
        return axios.get('/web-api/tournament/' + id);
    },

    register(id) {
        return axios.post('/web-api/tournaments-registration', {
            tournament_id: id,
        })
    },

    findGame(id) {
        return axios.get('/web-api/games/tournament/room/find', {
            params: {
                id: id
            }
        })
    }
}